export const NO_RESULTS_MESSAGE = 'No Customers Found';
